<template>
  <!-- 방문예약 현황 화면 -->
  <div>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-view-list-outline</v-icon>방문예약 신청 현황
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
            <div class="d-flex mb-n6">
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" :cLabel="'신청일'" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <IronDate ref="IronDateRef" v-model="sVisitNowSelectDate" @update="onVisitDateRangeChange" :cLabel="'방문일'" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <v-select
                :items="zSearchSort"
                v-model="cSort"
                @change="GetReqLog()"
                label="구분"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                dense
                hide-details
                persistent-placeholder
              ></v-select>
              <v-select
                :items="zState"
                v-model="cState"
                @change="GetReqLog()"
                label="상태"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                dense
                hide-details
                persistent-placeholder
              ></v-select>
              <v-text-field v-model="cNowSearchKeyWord" @keyup.enter="GetReqLog()" @click:append="GetReqLog()" append-icon="search" label="검색어" placeholder="신청자 or 방문자 or 소속 or 담당자" class="hidden-md-and-down" dense persistent-placeholder hide-details style="width:260px;"></v-text-field>
            </div>
            <IronDate ref="IronDateRef" v-model="sNowSelectDate" @update="onDateRangeChange" :cLabel="'신청일'" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-2">
            <IronDate ref="IronDateRef" v-model="sVisitNowSelectDate" @update="onVisitDateRangeChange" :cLabel="'방문일'" style="width:100%" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex order-sm-1">
            <v-select
              :items="zSearchSort"
              v-model="cSort"
              @change="GetReqLog()"
              label="구분"
              class="mr-1 hidden-lg-and-up"
              dense
              hide-details
              persistent-placeholder
            ></v-select>
            <v-select
              :items="zState"
              v-model="cState"
              @change="GetReqLog()"
              label="상태"
              class="ml-1 hidden-lg-and-up"
              dense
              hide-details
              persistent-placeholder
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-3">
            <v-text-field v-model="cNowSearchKeyWord" @keyup.enter="GetReqLog()" @click:append="GetReqLog()" append-icon="search" label="검색어" placeholder="신청자 or 방문자 or 소속 or 담당자" class="hidden-lg-and-up" dense persistent-placeholder hide-details ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :headers="headers"
        :items="Records"
        v-model="selected"
        :single-select="bSingleSelect"
        @click:row="handleClick"
        @dblclick:row="handleDoubleClick(selected[0])"
        :items-per-page="15"
        item-key="cReqId"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cWorkerList="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="max-width:120px;min-width:80px;"
                class="text-truncate"
                v-bind="attrs"
                v-on="on"
              >
                {{item.cWorkerList}}
              </div>
            </template>
            <div style="max-width:300px !important;">{{item.cWorkerList}}</div>
          </v-tooltip>
        </template>
        <template v-slot:item.cCreateDateTime="{ item }">
          {{item.cCreateDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.cSort="{ item }">
          <v-chip label small :color="getSortColor(item.cSort)" dark>{{ getSort(item.cSort) }}</v-chip>
        </template>
        <template v-slot:item.cVisitDate="{ item }">
          <div style="min-width:170px;">{{getDate(item)}}</div>
        </template>
        <template v-slot:item.cZone="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="max-width:220px;min-width:150px;"
                class="text-truncate"
                v-bind="attrs"
                v-on="on"
              >
                {{item.cZone}}
              </div>
            </template>
            <div style="max-width:300px !important;">{{item.cZone}}</div>
          </v-tooltip>
        </template>
        <template v-slot:item.cState="{ item }">
          <v-chip label small :color="getStateColor(item.cState)" dark>{{ getState(item.cState) }}</v-chip>
        </template>
        <template v-slot:item.cPurpose="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="max-width:220px;min-width:70px;"
                class="text-truncate"
                v-bind="attrs"
                v-on="on"
              >
                {{item.cPurpose}}
              </div>
            </template>
            <div style="max-width:300px !important;">{{item.cPurpose}}</div>
          </v-tooltip>
        </template>

        <template v-slot:item.cEndComment="{ item }">
          <v-btn v-if="item.cState != 'REQ' && (((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && CustomInfo.CorpId == item.cCorpId )||((CustomInfo.Manager == 'N') && CustomInfo.CustomId == item.cCustomId && CustomInfo.CorpId == item.cCorpId))" @click="OpenDialog(item)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
        </template>
        <template v-slot:item.cEdit="{ item }">
          <div v-if="item.cCustomId == CustomInfo.CustomId && item.cState == 'REQ'" class="d-flex">
            <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>

    <DelDialog ref="DelDialogRef" @DelData="DelData"/>
    <EditDialog ref="EditDialogRef" @ChangeReq="ChangeReq"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";

import EditDialog from "../components/EditDialog.vue";
import DelDialog from "../components/DelDialog.vue";
import ResponseDialog from "../components/ResponseDialog.vue";

export default {
  components: {
    IronDate,
    EditDialog,
    DelDialog,
    ResponseDialog,
  },
  data: () => ({
    bSingleSelect : true,
    bApplyDate : false,
    cNoMsg : "",
    ChangableHeight : "",
    cNowSearchKeyWord : "",
    cState : "ALL",
    cSort : "ALL",
    sNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    cStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    cEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    sVisitNowSelectDate :  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    sVisitStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sVisitEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    selected : [],
    Records : [],
    headers: [
      { text: 'NO', align: 'start', value: 'sNum',width:"10"},
      { text: '신청자', align: 'start', value: 'cCustomNm',width:"80"},
      { text: '방문자', align: 'start', value: 'cWorkerList',width:"80"},
      { text: '신청일자', align: 'start', value: 'cCreateDateTime',width:"120"},
      { text: '구분', align: 'start', value: 'cSort',width:"80"},
      { text: '방문일', value: 'cVisitDate',width:"210"},
      { text: '방문장소', value: 'cZone'},
      { text: '방문목적', value: 'cPurpose'},
      { text: '상태', value: 'cState', width:"80", align : "center"},
      { text: '의견', value: 'cEndComment',width:"80",align : "center"},
      { text: '작업', value: 'cEdit', width:"80", align : "center"},
    ],
  }),
  computed: {  
    ...mapState(["CustomInfo","zSearchSort","zSort","zState"]),
  },
  created() {
  },

  mounted() {
    this.Initialize();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    Initialize(){
      this.bApplyDate = true;
      this.DataInit();
      this.GetReqLog();
    },

    // 데이터 초기화 하기
    DataInit () {
      this.cNowSearchKeyWord = "";
      this.cStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.cEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.sNowSelectDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.sVisitStartDate = Util.sFormatDate(Util.sBefore1Moth());
      this.sVisitEndDate = Util.sFormatDate(Util.sAfter1Moth());
      this.sVisitNowSelectDate =  Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth());
      this.cState = "ALL";
      this.cSort = "ALL";
    },

    // 삭제 확인 다이올로그 창 열기
    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("Visit",item,this.Records.indexOf(item));
    },
    
    // 확인 버튼 클릭 시 삭제 함수 실행하기
    DelData(index,item){
      this.DelReqLog(index,item)
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.cStartDate = Util.sFormatDate(daterange.startDate);
      this.cEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.cStartDate + " ~ " +  this.cEndDate;
      this.GetReqLog();
    },

    onVisitDateRangeChange(daterange){
      this.sVisitStartDate = Util.sFormatDate(daterange.startDate);
      this.sVisitEndDate = Util.sFormatDate(daterange.endDate);
      this.sVisitNowSelectDate = this.sVisitStartDate + " ~ " +  this.sVisitEndDate;
      this.GetReqLog();
    },

    // 수정후 정보 변경하기(통신을 사용하지 않음)
    ChangeReq(item,index){
      this.Records[index].cCarNo = item.cCarNo
      this.Records[index].cCarType = item.cCarType
      this.Records[index].cPurpose = item.cPurpose
      this.Records[index].cSort = item.cSort
      this.Records[index].cStartDate = item.cStartDate.substring(0,10);
      this.Records[index].cEndDate = item.cEndDate.substring(0,10);
      this.Records[index].cSubPurpose = item.cSubPurpose
      this.Records[index].cZone = item.cZone
      this.Records[index].cWorkerList = item.cWorkerList
      // this.Records.splice(index,1,item)
    },

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item) {
      // ((CustomInfo.Manager == 'S' || CustomInfo.Manager == 'M') && CustomInfo.CorpId == item.cCorpId )||((CustomInfo.Manager == 'N') && CustomInfo.CustomId == item.cCustomId && CustomInfo.CorpId == item.cCorpId)
      if (this.CustomInfo.CorpId != item.cCorpId) return
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager == "N") return
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager != "N" && item.cState == BasicInfo.REQ_TYPE_VISIT_STATE_REQ) return

      if (this.selected.length > 0 || item.cReqId != undefined) {
        this.OpenDialog(this.selected[0])
      }
    },

    OpenDialog(item) {
      if (item.cState == BasicInfo.REQ_TYPE_VISIT_STATE_REQ) {
        let EditIndex = this.Records.indexOf(item);
        this.$refs.EditDialogRef.ShowDialog(item,EditIndex);
      } else {
        this.$refs.ResponseDialogRef.ShowDialog(item,this.getState(item.cState),true)
      }
    },

    //REQ:신청중, OK:승인, ING:보류, NG:반려
    getStateColor(cState){
      return this.zState.find((e) => {return e.value == cState})?.color
    },

    // cState값에 맞게 한글 표기하기
    getState(cState){
      return this.zState.find((e) => {return e.value == cState})?.text
    },

    // 0 : 일반방문, 1 : 장기출입
    getSortColor(cSort){
      return this.zSort.find((e) => {return e.value == cSort})?.color
    },

    // cState값에 맞게 한글 표기하기
    getSort(cSort){
      return this.zSort.find((e) => {return e.value == cSort})?.text
    },

    // 일반방문과 장기출입 다르게 날짜 표시
    getDate(item){
      if (item.cSort == "1") {
        return item.cStartDate.substring(0,10) + " ~ " + item.cEndDate.substring(0,10)
      } else {
        return item.cStartDate.substring(0,10)
      }
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    // 방문 신청 현황 가져오기
    GetReqLog() {
      this.Records = [];

      var posData = {
        Manager : this.CustomInfo.Manager,
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        NowSearchKeyWord : this.cNowSearchKeyWord,
        State : this.cState,
        Sort : this.cSort,
        ReqStartDate : this.cStartDate,
        ReqEndDate : this.cEndDate,
        VisitStart : this.sVisitStartDate,
        VisitEnd : this.sVisitEndDate,
        ApplyDate : this.bApplyDate,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "GetReqLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for (let i =0; i < res.data.Result.length; i++) {
                res.data.Result[i].sNum = i +1
                res.data.Result[i].cCreateDateTime = res.data.Result[i].cCreateDateTime.substring(0,10)
              }
            } else {
              this.ShowNoResultMsg()
            }

            this.Records = res.data.Result
            this.bApplyDate = false;
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // 방문 신청 현황 삭제하기
    DelReqLog(index,item) {
      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        CustomId : item.cCustomId,
        ReqId : item.cReqId,
        CorpId : this.CustomInfo.CorpId,
      };

      axios
        .post(process.env.VUE_APP_UIL_API + "DelReqLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index, 1);
            for (let i = 0; i < this.Records.length;i ++){
              this.Records[i].sNum = i+1
            }
            EventBus.$emit("onShowMsg",false,  "삭제되었습니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>